var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.79 10H9V1C9 0.45 8.55 0 8 0C7.45 0 7 0.45 7 1V10H5.21C4.76 10 4.54 10.54 4.86 10.85L7.65 13.64C7.85 13.84 8.16 13.84 8.36 13.64L11.15 10.85C11.46 10.54 11.24 10 10.79 10ZM0 17C0 17.55 0.45 18 1 18H15C15.55 18 16 17.55 16 17C16 16.45 15.55 16 15 16H1C0.45 16 0 16.45 0 17Z","fill":"#334155"}));
}

Icon.defaultProps = {"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
